import React from 'react';

import {
    Layout,
    LinkButton,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './Fallback.scss';

const Fallback = ({
    t,
    backButtonUrl,
    backButtonText,
}) => {
    const hasBackButton = !!backButtonText && !!backButtonUrl;

    return (
        <Layout
            className={styles.container}
            gutters={1}
            useNewBreakpoints
        >
            <Typography variant="h5">{t('unknown-form-error')}</Typography>
            {hasBackButton && (
                <LinkButton
                    className={styles.button}
                    href={backButtonUrl}
                >
                    {backButtonText}
                </LinkButton>
            )}
        </Layout>
    );
};

export default localize(Fallback, 'baseApp');
